module.exports = __webpack_public_path__ + "img/14_48.348ce5ff.png";